
  import { Vue, Component } from 'vue-property-decorator';
  import { inject } from 'inversify-props';
  import { data } from "./mc-summary.data";
  import { MealCountDtoViewModel } from '@/view-models';
  import { ReceivedMeals, ServingLine, MealCountDto } from '@/models';
  import { ISiteService } from '@/services';

  @Component
  export default class McSummaryTests extends Vue {
    @inject() private siteService!: ISiteService;
    model!: MealCountDtoViewModel;
    testReceiveCounts!: ReceivedMeals;
    testServeCounts!: ServingLine;
    testTotalCounts!: MealCountDto;
    fluent = {};

    created() {
      this.model = data.model;
      this.testReceiveCounts = data.testReceivedMeals;
      this.testServeCounts = data.testServingLine;
    }

    mounted() {
      this.siteService.loadAppData(data);
    }
  }
